<template>
    <div class="page-title-container">
        <span>{{pageTitle}}</span>
    </div>
</template>
<script>
export default {
    name: 'PageTitle',
    props: ['pageTitle'],
    data() {
        return {}
    }
}
</script>
<style lang="scss" scoped>
@import './PageTitle.scss';
</style>


// WEBPACK FOOTER //
// src/components/common/crumbs/PageTitle.vue